/* Cart-upsell size sheet.
   Loaded as a theme asset, NOT inline in the snippet: the cart drawer re-renders
   over AJAX and <script> tags injected via innerHTML never execute, so an inline
   copy was dead exactly when it was needed. The listener is delegated on document
   so it keeps working across every drawer re-render. */
/* Cart-upsell size sheet. Reuses the .sy-size-sheet component the PDP sticky
     bar builds, so the two look identical. Intercepts the Add tap on a
     multi-variant upsell card, lets the shopper pick a size, writes the chosen
     variant into the form's hidden id input, then submits the real form so the
     add still goes through the theme's normal cart path. */
  (function () {
    if (window.__syCartSizeSheet) return;
    window.__syCartSizeSheet = true;

    function buildSheet() {
      var sheet = document.getElementById('sy-cart-size-sheet');
      if (sheet) return sheet;
      sheet = document.createElement('dialog');
      sheet.id = 'sy-cart-size-sheet';
      sheet.className = 'sy-size-sheet';
      sheet.innerHTML =
        '<div class="sy-size-sheet__handle" aria-hidden="true"></div>' +
        '<p class="sy-size-sheet__title">Select a size</p>' +
        '<div class="sy-size-sheet__opts" data-sy-opts></div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
      return sheet;
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var card = target.closest('.sy-cart-pairs__card');
      if (!card || !card.querySelector('.sy-cart-pairs__needs-size')) return;
      var btn = target.closest('button[type="submit"], .sy-cart-pairs__add');
      if (!btn) return;

      var form = card.querySelector('form');
      var tpl = card.querySelector('template.sy-cart-pairs__sizes');
      var idInput = form && form.querySelector('input[name=id]');
      if (!form || !tpl || !idInput) return;

      event.preventDefault();
      event.stopPropagation();

      var sheet = buildSheet();
      var opts = sheet.querySelector('[data-sy-opts]');
      opts.innerHTML = '';
      opts.appendChild(tpl.content.cloneNode(true));

      var titleEl = card.querySelector('.sy-cart-pairs__needs-size');
      var name = titleEl && titleEl.getAttribute('data-product-title');
      var heading = sheet.querySelector('.sy-size-sheet__title');
      if (heading) heading.textContent = name ? 'Select a size — ' + name : 'Select a size';

      opts.querySelectorAll('.sy-size-sheet__chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.disabled) return;
          idInput.value = chip.getAttribute('data-variant-id');
          sheet.close();
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        });
      });

      if (typeof sheet.showModal === 'function') sheet.showModal();
      else sheet.setAttribute('open', '');
    }, true);
  })();
